export enum TYPES {
  SET_ATTRIBUTE = 'setAttribute',
  CLEAR_USER = 'clearUser',
  SET_RAF_ELIGIBILITY = 'setRafEligibility',
}

export default TYPES
